<template>
  <div class="flex items-center file-input-block">
    <div
      class="file-input-content"
      :class="{'flex justify-between items-center w-full': notPreview}"
    >
      <input
        id="image"
        ref="fileInputField"
        type="file"
        class="inputfile"
        @change="onFileSelected"
      />
      <label
        for="image"
        class="text-xs"
      >
        <span
          v-if="loadFile"
          class="text-green-500"
        >
          {{ alreadyLoadText }}
        </span>
        <span v-else>{{label}} </span>

      </label>
      <button
        v-if="loadFile"
        class="btn btn-default btn-small"
        @click="removeFile"
      >
        {{ $t('main.button_delete') }}
      </button>
      <button
        v-else
        class="btn btn-default btn-small"
        @click="selectFile"
      >
        {{ $t('client.file_input_block.button_upload') }}
      </button>
    </div>
    <slot></slot>
  </div>
</template>
<script>
const defaultImagePreview = "/images/design/bg-thumb-elements.png";
export default {
  name: "FileInputBlockNoPreview",
  props: {
    prefill: {
      type: String,
      required: false,
      default: "",
    },
    loadedFile: {
      type: [String, File],
      required: false,
      default: "",
    },
    selectedImageFileNameDefault: {
      type: String,
      required: false,
      default: "",
    },
    alreadyLoadText: {
      type: String,
      required: false,
      default: "",
    },
    notPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imagePreview: null,
      label: "",
      loadFile: null,
    };
  },
  created() {
    this.imagePreview = this.prefill || defaultImagePreview;
    this.label = this.selectedImageFileNameDefault;
    this.loadFile = this.loadedFile;
  },
  methods: {
    selectFile() {
      this.$refs.fileInputField.click();
    },
    onFileSelected(event) {
      this.$emit("selected-file", event.target.files[0]);
      this.imagePreview = this.defaultImagePreview;
      this.label = null;
      let file = event.target.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.label = file[0].name;
        this.loadFile = file[0].name;
      }
    },
    removeFile() {
      this.$emit("remove-file");
      this.imagePreview = this.defaultImagePreview;
      this.label = this.selectedImageFileNameDefault;
      this.loadFile = null;
    },
  },
};
</script>
<style scoped>
.file-input-content {
  display: flex;
  align-items: center;
  column-gap: 40px;
}
label {
  margin: 0;
}
</style>
